import React from "react";
import Navbar from "../menu/Navbar";

export default function Header() {
  return <header></header>;
}
